/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { AppStates } from '../../../enums';

export const canCancelInterval = (appState: AppStates): boolean => [
    AppStates.SessionExpired,
    AppStates.Destroyed,
].includes(appState);

export const canViewPortalPages = (appState: AppStates): boolean => [
    AppStates.LoggedIn,
    AppStates.SessionExpired,
    AppStates.Destroyed,
].includes(appState);
